import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { DriverCard, LoadStatus, Orders } from '../../interfaces';
import { DataServiceService } from '../../services/data-service.service';
import { MessageService } from 'primeng/api';
import { WashoutDialogComponent } from '../washout-dialog/washout-dialog.component';

@Component({
  selector: 'app-status-update-dialog',
  templateUrl: './status-update-dialog.component.html',
  styleUrl: './status-update-dialog.component.scss'
})
export class StatusUpdateDialogComponent {

  constructor(private dataServiceService: DataServiceService, private messageService: MessageService) {}

  @Output() openWashoutDialog = new EventEmitter<number>();

  @Input() driverCards: DriverCard[] = [];
  @Input() allOrders: Orders[] = [];
  @Input() selectedDriverDispatch: number = -1;
  @Input() selectedOrderId: number = -1;
  // @Input() washoutDialog: any = null;
  @Input() saltTypeDialog: any = null;

  // @Output() updateTrailerLocationRequested = new EventEmitter<{ trailerId: number, locationId: number }>();

  showstatusnotes: boolean = false;
  selectedStatus: string = '';
  timeLoaded: Date = new Date();
  timeDelivered: Date = new Date();
  showStatusDialog: boolean = false;

  statusOptions = [
    { label: 'Scheduled', value: 'Scheduled' },
    { label: 'Loaded', value: 'Loaded' },
    { label: 'Delivered', value: 'Delivered' },
    { label: 'Cancelled', value: 'Cancelled' },
  ];


  openStatusNotes(driverId: number, loadId: number) {
    this.selectedDriverDispatch = driverId;
    this.selectedOrderId = loadId;
    this.showstatusnotes = true;

    // Set current time
    const now = new Date();
    this.timeLoaded = now;
    this.timeDelivered = now;

    let driver = this.driverCards.find(d => d.driver.driver_id == driverId);
    if (driver) {
      let load = driver.dispatchOrders.find(l => l.order_id == loadId);
      if (load) {
        const orderinfo = this.allOrders.find(order => order.order_id === loadId);
        this.selectedStatus = orderinfo?.load_status || '';

      }
    }
  }
  


  saveStatusAndNotes() {
    let driver = this.driverCards.find(d => d.driver.driver_id == this.selectedDriverDispatch);

    if (!driver) {
      console.error('Driver not found for the given dispatch ID:', this.selectedDriverDispatch);
      return;
    }

    let order = this.allOrders.find(o => o.order_id == this.selectedOrderId);

    // Check if we're setting status to 'Loaded' and if it's a salt trailer
    if (this.selectedStatus === 'Loaded' && order?.trailer_id) {
      // Check if this is a salt trailer
      this.checkSaltTrailerStatus(order, () => {
        this.updateOrderStatus(order);
      });
    } else if (this.selectedStatus === 'Delivered' && order?.trailer_id) {
      this.openWashoutDialog.emit(this.selectedOrderId);
      this.updateOrderStatus(order as Orders);
    } else {
      this.updateOrderStatus(order as Orders);
    }
  }

    // Simplified method - all logic now handled by the salt dialog component
    private checkSaltTrailerStatus(order: any, callback: () => void) {
      this.saltTypeDialog.checkAndHandleSaltTrailer(order, callback);
      }


      private updateOrderStatus(order: any) {
        const updatedData: Partial<Orders> = {
          load_status: this.selectedStatus as LoadStatus || null,
          time_loaded: undefined,
          time_delivered: undefined
        };
    
        switch (this.selectedStatus) {
          case 'Loaded':
            updatedData.time_loaded = this.timeLoaded || null;
            if (order?.trailer_id && order?.supplier_id) {
              this.updateTrailerLocation(order.trailer_id, order.supplier_id);
            }
            break;
          case 'Delivered':
            updatedData.time_delivered = this.timeDelivered || null;
            if (order?.trailer_id && order?.receiver_id) {
              this.updateTrailerLocation(order.trailer_id, order.receiver_id);
            }
            // Update trailer status to Empty when delivered
            if (order?.trailer_id) {
              this.dataServiceService.updateTrailer(order.trailer_id, {
                status: 'Empty'
              }).subscribe({
                next: () => {
                  console.log(`Trailer ${order.trailer_id} status updated to Empty after delivery`);
                },
                error: (error) => {
                  console.error('Failed to update trailer status to Empty:', error);
                }
              });
            }
            break;
        }
    
        this.dataServiceService.updateOrder(this.selectedOrderId, updatedData).subscribe({
          next: (response) => {
            if (this.selectedStatus === 'Delivered') {
              this.showStatusDialog = true;
            }
            this.showstatusnotes = false;
          },
          error: (error) => {
            console.error('Failed to update order:', error);
          }
        });
      }


    updateTrailerLocation(trailerId: number, locationId: number) {
    const updateData = {
      customer_id: locationId
    };

    this.dataServiceService.updateTrailer(trailerId, updateData)
      .subscribe({
        next: (updatedTrailer) => {
          this.messageService.add({
            severity: 'success',
            summary: 'Updated',
            detail: `Trailer location updated successfully`
          });
        },
        error: (error) => {
          console.error('Failed to update trailer location:', error);
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: 'Failed to update trailer location'
          });
        }
      });
  }
}
